/**
 * «¿Cómo está ahora?» — Mejor / Igual / Peor / Ya no hay / No lo sé. Botones
 * grandes, una sola decisión; la misma rejilla en la pregunta del asistente
 * (`FollowUpStep`) y en la revisión pedida (`FollowUpReviewScreen`), para que el
 * trabajador vea siempre lo mismo. Lo dice quien está delante de la planta
 * (decisión D19); «No lo sé» es una respuesta válida.
 */
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import type { FollowUpVerdict } from "@/lib/pests/followUp";

const OPTION =
  "rounded-2xl bg-white border border-[#b6dded] shadow-sm p-4 flex items-center justify-center text-base font-semibold active:scale-[0.98] transition-transform min-h-[64px]";
const VERDICTS: FollowUpVerdict[] = ["better", "same", "worse", "gone", "unknown"];

export function VerdictButtons({ value = null, onPick }: { value?: FollowUpVerdict | null; onPick: (v: FollowUpVerdict) => void }) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-2 gap-2" data-testid="verdict-buttons">
      {VERDICTS.map((v) => (
        <button
          key={v}
          type="button"
          onClick={() => onPick(v)}
          className={cn(
            OPTION,
            v === "gone" && value !== v && "border-emerald-300 bg-emerald-50",
            v === "unknown" && "col-span-2 min-h-[52px]",
            v === "unknown" && value !== v && "text-muted-foreground",
            /* Lo elegido va RELLENO (27-09-2026): con solo un anillo, «Ya no hay» —que va
               teñido de verde— parecía el elegido aunque se hubiera tocado «Peor». */
            value === v && "border-[#1d7f8a] bg-[#1d7f8a] text-white ring-2 ring-[#1d7f8a]/25",
          )}
          data-testid={`followup-verdict-${v}`}
          data-selected={value === v ? "true" : "false"}
          aria-pressed={value === v}
        >
          {t(`worker.incident.followup.${v}`)}
        </button>
      ))}
    </div>
  );
}
